import { createFileRoute, notFound } from "@tanstack/react-router";
import { parseUserProfileHandle } from "~/features/user-profile/profile-handle";
import { UserProfilePagePending } from "~/features/user-profile/routing/user-profile-page-pending";

export const Route = createFileRoute("/_app/user/$userId")({
  pendingComponent: UserProfilePagePending,
  pendingMs: 0,
  loader: ({ context, params, preload }) => {
    if (!parseUserProfileHandle(params.userId)) throw notFound();

    const moduleTask = import("~/features/user-profile/user-profile-route");
    // Intent may warm data, but a click must never wait for all wallet reads.
    // The mounted collection owns loading, errors, and unknown-handle states.
    void moduleTask
      .then(({ preloadUserProfileRoute }) =>
        preloadUserProfileRoute(context, params.userId),
      )
      .catch(() => undefined);
    if (preload) return moduleTask.then(() => undefined);
  },
});
